import type { JwtPayload, SupabaseClient } from '@supabase/supabase-js';
import { queryOptions, useQuery } from '@tanstack/vue-query';
import { useSupabaseClient } from '~/composables/useSupabaseClient';
import { useSupabaseUser } from '~/composables/useSupabaseUser';
import type { Database } from '~~/types/Supabase';

export type CreateCreatorQueryOptions = {
	supabaseClient: SupabaseClient<Database>;
	user: MaybeRef<JwtPayload | null>;
};

export const createCreatorQuery = (
	options: CreateCreatorQueryOptions,
) => queryOptions({
	queryKey: ['creator'],
	queryFn: async () => {
		if (!unref(options.user)) return null;

		const result = await options.supabaseClient
			.from('creators')
			.select('*')
			.eq('user_id', unref(options.user)!.sub)
			.single();

		return result.data;
	},
	enabled: computed(() => !!unref(options.user)),
});

export const useCreatorQuery = () => {
	const supabase = useSupabaseClient();
	const user = useSupabaseUser();

	const query = useQuery(createCreatorQuery({ supabaseClient: supabase, user }));

	return query;
};
